module.exports = __webpack_public_path__ + "img/bg.c6804715.jpg";